import baseVariables from 'bitmovin-web-ui/src/styles/baseVariables';
import React from 'react';
import styled from 'styled-components';

import BoundImageModal from '../../components/boundImageModal';
import {maxExtendedWidth, pxToEm} from '../../components/globalStyles';
import WrapperAppUl from '../../components/wrapperAppUl';
import AwardReaderChoiceSvg from '../../media/aboutUsPageView/award_reader_choice.png';
import Deloitte from '../../media/aboutUsPageView/deloitte_2021.png';
import EmmyAward from '../../media/aboutUsPageView/emmy_award.png';
import MPEGDashSvg from '../../media/aboutUsPageView/mpeg_dash.svg';
import PapersSvg from '../../media/aboutUsPageView/papers.svg';
import PatentsSvg from '../../media/aboutUsPageView/patents.svg';
import WorldwideOfficesSvg from '../../media/aboutUsPageView/worldwide_offices.svg';

//#region Styled Components

const StyledWrapperDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  > div:first-child {
    flex: 4;
    margin-right: ${pxToEm(50)}em;
  }

  > div:last-child {
    flex: 5;
  }
`;

const StyledWrapperAppUl = styled(WrapperAppUl)`
  font-size: ${pxToEm(22)}em;
  font-weight: bold;
  color: ${baseVariables.colors.midnight};
`;

const StyledList = styled.ul`
  margin: ${pxToEm(58)}em 0 0;
  padding: ${pxToEm(40)}em ${pxToEm(100)}em ${pxToEm(40)}em ${pxToEm(50)}em;
  background-color: ${baseVariables.colors.lightBlueGray};
  border-radius: 6px;

  > li {
    list-style: none;
    :not(:last-child) {
      margin-bottom: ${pxToEm(30)}em;
    }
  }
`;

const StyledLi = styled.li`
  display: flex;
  align-items: center;
`;

const StyledLiImgWrapper = styled.div`
  width: ${pxToEm(70)}em;
  text-align: right;
`;

const listFontSizePx = 21;
const StyledLiTextWrapper = styled.div`
  font-size: ${pxToEm(listFontSizePx)}em;
  font-weight: bold;
  color: ${baseVariables.colors.midnight};
  margin-left: ${pxToEm(32)}em;

  > small {
    font-size: ${pxToEm(16) / pxToEm(listFontSizePx)}em;
    font-weight: normal;
  }
`;

const StyledImg = styled.img`
  width: 100%;
`;

const StyledImgModal = styled(BoundImageModal)`
  width: 100%;

  // @media (max-width: ${maxExtendedWidth}) {
  //   width: 100%;
  // }
`;

//#endregion

const WorldwideTeamSection: React.FunctionComponent = () => {
  const worldOffices = <StyledImg src={WorldwideOfficesSvg} alt="Worldwide offices" />;

  return (
    <StyledWrapperDiv>
      <div>
        <StyledWrapperAppUl>
          <li>Worldwide Team for Worldwide Customers</li>
        </StyledWrapperAppUl>

        <StyledList>
          <StyledLi>
            <StyledLiImgWrapper>
              <img src={PatentsSvg} alt="Patents icon" />
            </StyledLiImgWrapper>
            <StyledLiTextWrapper>
              <span>40+ Patents</span>
            </StyledLiTextWrapper>
          </StyledLi>

          <StyledLi>
            <StyledLiImgWrapper>
              <img src={MPEGDashSvg} alt="MPEG Dash icon" />
            </StyledLiImgWrapper>
            <StyledLiTextWrapper>
              <span>Co-created the MPEG-DASH standard</span>
            </StyledLiTextWrapper>
          </StyledLi>

          <StyledLi>
            <StyledLiImgWrapper>
              <img src={PapersSvg} alt="Papers icon" />
            </StyledLiImgWrapper>
            <StyledLiTextWrapper>
              <span>50+ Papers in Multimedia and counting</span>
            </StyledLiTextWrapper>
          </StyledLi>

          <StyledLi>
            <StyledLiImgWrapper>
              <img src={EmmyAward} alt="Emmy® Award" />
            </StyledLiImgWrapper>
            <StyledLiTextWrapper>
              <span>Emmy® Award</span>
            </StyledLiTextWrapper>
          </StyledLi>

          <StyledLi>
            <StyledLiImgWrapper>
              <img src={Deloitte} alt="Deloitte icon" />
            </StyledLiImgWrapper>
            <StyledLiTextWrapper>
              <span>Deloitte 2021</span>
              <br />
              <small>list of world’s fastest growing technology companies</small>
            </StyledLiTextWrapper>
          </StyledLi>

          <StyledLi>
            <StyledLiImgWrapper>
              <img src={AwardReaderChoiceSvg} alt="Reader Choice award icon" />
            </StyledLiImgWrapper>
            <StyledLiTextWrapper>
              <span>Streaming Media Readers’ Choice Awards 2021</span>
              <br />
              <small>Best Per-Title Encoding Solution</small>
              <small>Best Analytics/Quality of Experience (QoE)</small>
              <small>Best New Streaming Innovation</small>
            </StyledLiTextWrapper>
          </StyledLi>
        </StyledList>
      </div>

      <div>
        <StyledImgModal boundComponent={worldOffices} source={WorldwideOfficesSvg} />
      </div>
    </StyledWrapperDiv>
  );
};

export default WorldwideTeamSection;
